import React from 'react'
import { Link } from 'react-router-dom';

import { mobileView, isArabic, viewerMode } from '../global';
import logoWhite from '../images/Logo_white.svg';
import social from "../images/social.svg";

import "../styles/global.css";
import "./styles.css"

const Footer = () => {
 
  const termsStr = isArabic ?'الشروط والأحكام':'Terms & Conditions'
  const privacyStr = isArabic ?'الخصوصية':'Privacy Policy'
  const jobsStr = isArabic ?'الوظائف':'Jobs'
  const faqStr = isArabic ?'الاسئلة الشائعة':'Frequently Asked Questions'
  const copyrightSrr = isArabic?'كل حقوق النشر محفوظة لجمهور هب © 2024':'All rights reserved to JamhoorHub © 2024'

  if (mobileView)
    return (
  <div>
      <div className="Footer" id="footer">
      <div className="content">
      <br />

      <section className="Column CrossCenter">
        <img src={logoWhite}/>
        <br/>
        <div style={{lineHeight:viewerMode==1?'20px':'30px'}}><Link to={isArabic?'/ar/terms':'/en/terms'}><div className="SubHeaderSmall White">{termsStr}</div></Link></div>
        <div style={{lineHeight:viewerMode==1?'20px':'30px'}}><Link to={isArabic?'/ar/privacy':'/en/privacy'}><div className="SubHeaderSmall White">{privacyStr}</div></Link></div>
        <div style={{lineHeight:viewerMode==1?'20px':'30px'}}><Link to={isArabic?'/ar/jobs':'/en/jobs'}><div className="SubHeaderSmall White">{jobsStr}</div></Link></div>
        <div style={{lineHeight:viewerMode==1?'20px':'30px'}}><Link to={isArabic?'/ar/faq':'/en/faq'}><div className="SubHeaderSmall White">{faqStr}</div></Link></div>
        <hr className="Divider" />
        <div className="SubHeaderSmall White">JamhoorHub©</div>
        <br/>
        <img src={social}  />
      </section>
      <br />
      </div>
      </div>
      <div className="SubHeaderSmall" >{copyrightSrr}</div>
      <br/>
      </div>
  )
  else
    return (
      <div className="Footer" id="footer">
        <div className="content">
          <br /><br /><br />
        
          <section className="Row MainSpaceBetween CrossCenter">
            <section className="Row">
              <Link to={isArabic?'/ar/terms':'/en/terms'}><div className="SubHeaderSmall White">{termsStr}</div></Link>&nbsp;&nbsp;
              <div className="SubHeaderSmall White Trans">|</div>&nbsp;&nbsp;
              <Link to={isArabic?'/ar/privacy':'/en/privacy'}><div className="SubHeaderSmall White">{privacyStr}</div></Link>&nbsp;&nbsp;
              <div className="SubHeaderSmall White Trans">|</div>&nbsp;&nbsp;
              <Link to={isArabic?'/ar/jobs':'/en/jobs'}><div className="SubHeaderSmall White">{jobsStr}</div></Link>&nbsp;&nbsp;
              <div className="SubHeaderSmall White Trans">|</div>&nbsp;&nbsp;
              <Link to={isArabic?'/ar/faq':'/en/faq'}><div className="SubHeaderSmall White">{faqStr}</div></Link>
            </section>
            <img src={logoWhite}/>
          </section>
            
          <hr className="Divider" />
          
          <section className="Row MainSpaceBetween">
              <div className="SubHeaderSmall White" >{copyrightSrr}</div>
            <section className="Row CrossCenter RowReverse">
              <div className="SubHeaderSmall White">{isArabic?'JamhoorHub©':'©JamhoorHub'}</div>&nbsp;&nbsp;
              <div className="White Trans">|</div>&nbsp;&nbsp;
              <img src={social} />
            </section>
          </section>
          <br /><br />
        </div>
      </div>
    )
}


export default Footer
